import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  ExtraSpellLists,
} from "@dndModels";
import { 
  SCHOOLS
} from "@dndModels/Constants";

import DandDAPI from "@utilities/smart_api";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import SelectSpellBox from "@dndComponents/select/SelectSpellBox";
import LoadingBox from "@components/input/LoadingBox";

type Props = {
  obj: ExtraSpellLists;
  onChange: (changed: ExtraSpellLists) => void; 
  disabled: boolean;
}

export interface State { 
  reloading: boolean;
  show_effect: number;
  special_refresh_rule: boolean;
}

const api = DandDAPI.getInstance();

class ExtraSpellListsInput extends Component<Props, State> {
  public static defaultProps = {
    disabled: false
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      reloading: false,
      show_effect: 0,
      special_refresh_rule: false
    };
  }

  componentDidMount() {
  }

  render() {
    if (this.state.reloading) {
      return (<Grid><LoadingBox /></Grid>);
    } else {
      const disabled = !api.online || this.props.disabled;
      return (
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 4
            }}>
            <SelectObjectBox
              name="Spell List"
              data_type="spell_list"
              values={this.props.obj.list_ids} 
              multiple
              disabled={disabled}
              onChange={(values: string[]) => {
                const obj = this.props.obj;
                obj.list_ids = values;
                this.props.onChange(obj);
              }} 
            />
          </Grid>
          <Grid
            size={{
              xs: 4
            }}>
            <SelectStringBox
              name="Spell Levels"
              values={ this.props.obj.levels } 
              options={["Any","Cantrips","Leveled Spells","1","2","3","4","5","6","7","8","9"]}
              multiple
              disabled={disabled}
              onChange={(values: string[]) => {
                const obj = this.props.obj;
                obj.levels = values;
                this.props.onChange(obj);
              }} 
            />
          </Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox
              name="Magic Schools"
              values={ this.props.obj.magic_schools } 
              options={SCHOOLS}
              extra_options={["Any"]}
              disabled={disabled}
              multiple
              onChange={(values: string[]) => {
                const obj = this.props.obj;
                if (values.includes("Any")) {
                  obj.magic_schools = ["Any"];
                } else {
                  obj.magic_schools = values;
                }
                this.props.onChange(obj);
              }} 
            />
          </Grid>
          <Grid
            size={{
              xs: 6
            }}>
            <SelectStringBox
              name="Ritual"
              value={ this.props.obj.allow_rituals === null ? "Any" : (this.props.obj.allow_rituals ? "Rituals Only" : "No Rituals") } 
              options={["Any","Rituals Only","No Rituals"]}
              disabled={disabled}
              onChange={(value: string) => {
                const obj = this.props.obj;
                switch(value) {
                  case "Any": obj.allow_rituals = null; break;
                  case "Rituals Only": obj.allow_rituals = true; break;
                  case "No Rituals": obj.allow_rituals = false; break;
                }
                this.props.onChange(obj);
              }} 
            />
          </Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SelectSpellBox 
              name="Specific Options" 
              multiple
              values={ this.props.obj.specific_spell_ids } 
              disabled={ this.props.disabled }
              onChange={(ids: string[]) => {
                const obj = this.props.obj;
                obj.specific_spell_ids = ids;
                this.props.onChange(obj);
              }} 
            />
          </Grid>
          <Grid
            size={{
              xs: 4
            }}>
            <SelectObjectBox
              name="Count as Being From Class"
              data_type="game_class"
              extra_options={["None"]}
              value={this.props.obj.count_as_class_id} 
              disabled={disabled}
              auto_sort
              dominant_only
              onChange={(value: string) => {
                const obj = this.props.obj;
                obj.count_as_class_id = value;
                this.props.onChange(obj);
              }} 
            />
          </Grid>
        </Grid>
      );
    }
  }
}

export default ExtraSpellListsInput;
